module.exports = "<ui-select ng-model=$ctrl.model name=bill-country autocomplete=\"billing country\" required form-field-errors> <ui-select-match placeholder=Country> {{ $select.selected.name }} </ui-select-match> <ui-select-choices repeat=\"item.key as item in $ctrl.countries | filter: $select.search track by item.key\"> <span ng-bind=item.name></span> </ui-select-choices> </ui-select>";


//////////////////
// WEBPACK FOOTER
// ./frontend/admin/app/modules/shared/journey-ui/payment/views/country.selector.html
// module id = 657
// module chunks = 0